"use client";

import { useProStatus } from "@/hooks/use-pro-status";

export function ProBadge() {
  const isPro = useProStatus();
  return (
    <span className="inline-flex min-w-[33px] min-h-[16px]">
      {isPro && (
        <span className="rounded bg-primary/10 px-1.5 py-0.5 text-[10px] font-semibold text-primary leading-none">
          PRO
        </span>
      )}
    </span>
  );
}
